import React from 'react';

export interface IProfileTableRecordProps {
  header: string;
  value: string;
  valueClassName: string;
}

const ProfileTableRecord: React.FC<IProfileTableRecordProps> = (props: IProfileTableRecordProps) => {
    return (
        <tr className="ProfileTableRecord">
            <td className="ProfileTableRecordHeader">{props.header}</td>
            <td className={props.valueClassName}>{props.value}</td>
        </tr>
    );
  }
  
  export default ProfileTableRecord;